/**
 * Lottie: product "New" badge + dynamic nodes (e.g. footer map marker).
 * Loads lottie-web once; exposes window.initLottieForElement(el).
 */
(function () {
  var LOTTIE_SRC = 'https://unpkg.com/lottie-web@5.12.2/build/player/lottie.min.js';
  var LOTTIE_SRI = ''; // Set when a pinned bundle is hosted in /assets/.

  // Cached MediaQueryList - re-queries are wasteful and don't react to OS-level changes either.
  var reducedMotionMQ = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;

  // Single in-flight load promise - multiple near-simultaneous IO callbacks would otherwise inject duplicate <script>s.
  var lottieLoadPromise = null;
  function loadLottieLib(cb) {
    if (typeof lottie !== 'undefined') { cb(); return; }
    if (!lottieLoadPromise) {
      lottieLoadPromise = new Promise(function (resolve, reject) {
        var s = document.createElement('script');
        s.src = LOTTIE_SRC;
        s.async = true;
        if (LOTTIE_SRI) { s.integrity = LOTTIE_SRI; s.crossOrigin = 'anonymous'; }
        s.onload = function () { resolve(); };
        s.onerror = function () {
          console.warn('[lottie] CDN failed to load; badges will not animate');
          lottieLoadPromise = null; // allow a retry on later intersection
          reject(new Error('lottie cdn failed'));
        };
        document.head.appendChild(s);
      });
    }
    lottieLoadPromise.then(cb).catch(function () { /* already warned */ });
  }

  function playOrPause(anim) {
    if (reducedMotionMQ && reducedMotionMQ.matches) anim.pause();
  }

  // Track animations per host element so we can destroy on disconnect.
  var animsByEl = new WeakMap();

  function initOne(el) {
    if (!el || el.getAttribute('data-lottie-ready')) return;
    var path = el.getAttribute('data-lottie-src');
    if (!path) return;
    el.setAttribute('data-lottie-ready', '1');
    var isProductNewBadge = el.classList.contains('product-badge__lottie');
    var anim = lottie.loadAnimation({
      container: el,
      renderer: 'svg',
      loop: !isProductNewBadge,
      autoplay: true,
      path: path,
    });
    animsByEl.set(el, anim);
    playOrPause(anim);
  }

  // Destroy the lottie animation tied to a host element (e.g. before unmounting).
  window.destroyLottieForElement = function (el) {
    var anim = el && animsByEl.get(el);
    if (anim) { try { anim.destroy(); } catch (_) {} animsByEl.delete(el); }
  };

  /**
   * Call after injecting a node with data-lottie-src (e.g. Google Maps marker).
   */
  function initLottieForElement(el) {
    if (!el || !el.getAttribute('data-lottie-src')) return;
    loadLottieLib(function () {
      if (typeof lottie === 'undefined') return;
      initOne(el);
    });
  }

  window.initLottieForElement = initLottieForElement;

  // Defer the 84 KiB lottie-web library until a badge actually enters the viewport.
  var scanIO = null;
  function scanStatic() {
    var nodes = document.querySelectorAll('.product-badge__lottie[data-lottie-src]');
    if (!nodes.length) return;
    if (!('IntersectionObserver' in window)) {
      loadLottieLib(function () { if (typeof lottie !== 'undefined') nodes.forEach(initOne); });
      return;
    }
    // Reuse observer across rescans so we don't leak instances.
    if (scanIO) scanIO.disconnect();
    var pending = [];
    scanIO = new IntersectionObserver(function (entries, observer) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        pending.push(entry.target);
        observer.unobserve(entry.target);
      });
      if (!pending.length) return;
      var toInit = pending.slice();
      pending.length = 0;
      loadLottieLib(function () {
        if (typeof lottie !== 'undefined') toInit.forEach(initOne);
      });
    }, { rootMargin: '200px' });
    nodes.forEach(function (n) { scanIO.observe(n); });
  }
  window.rescanLottieBadges = scanStatic;

  // Wait for DOM ready so badges parsed after this script (head loads) still get picked up.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scanStatic, { once: true });
  } else {
    scanStatic();
  }
  // Cleanup on bfcache eviction / pagehide.
  window.addEventListener('pagehide', function () { if (scanIO) { scanIO.disconnect(); scanIO = null; } }, { once: true });
})();
